import React from "react";
import { Typography, Box, Container } from "@mui/material";

const PresaSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        py: 2,
        position: "relative",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
          linear-gradient(
            to right,
            rgba(255, 247, 230, 0.8) 0%,
            rgba(255, 245, 220, 0.8) 35%,
            rgba(255, 245, 220, 0.8) 65%,
            rgba(255, 247, 230, 0.8) 100%
          ),
          repeating-linear-gradient(
            0deg,
            transparent,
            transparent 50px,
            rgba(177, 151, 119, 0.05) 50px,
            rgba(177, 151, 119, 0.05) 51px
          ),
          repeating-linear-gradient(
            90deg,
            transparent,
            transparent 50px,
            rgba(177, 151, 119, 0.05) 50px,
            rgba(177, 151, 119, 0.05) 51px
          )
        `,
          boxShadow: `
          inset 0 0 30px rgba(177, 151, 119, 0.2),
          inset 0 0 60px rgba(177, 151, 119, 0.1),
          0 0 10px rgba(177, 151, 119, 0.1)
        `,
          zIndex: -1,
        },
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: -20,
              right: -20,
              bottom: 0,
              background: "rgba(255, 250, 240, 0.5)",
              filter: "blur(10px)",
              zIndex: -1,
            },
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontWeight: 600,
              textAlign: "left",
              fontFamily: "Cinzel",
              color: "#BE9257",
              mb: 6,
              textShadow: "1px 1px 2px rgba(190, 146, 87, 0.2)",
              fontSize: { xs: "1.75rem", md: "2.25rem" },
              letterSpacing: "0.02em",
            }}
          >
            Decizia Nr. 35 din 27 februarie 2025
          </Typography>
          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-line",
              textAlign: "justify",
              lineHeight: 1.8,
              fontFamily: "Cormorant Garamond",
              color: "#800020",
              fontSize: { xs: "16px", md: "18px" },
              fontWeight: 500,
              letterSpacing: "0.01em",
            }}
          >
            {`Preasfințitul Părinte Iustin, Episcopul Maramureșului și Sătmarului, prin Decizia Nr. 35 din 27 februarie 2025, a numit, începând cu data de 1 martie 2025, pe Preacucernicul Părinte Valeriu Mircea Vana, în funcția de consilier eparhial al Sectorului Pelerinaje.

Părintele Valeriu Mircea Vana este absolvent de dublă specializare: Teologie Pastorală și Geografie–Turism, nivel licență și masterat, având și un Doctorat cu titlul: „Turismul cultural-religios și de pelerinaj din Maramureș”, obținând califivativul „Magna Cum Laude”. De asemenea, din anul 2012 deține brevet de manager în activitatea de turism.

Este angajat al Episcopiei Ortodoxe Române a Maramureșului și Sătmarului din anul 2017 și preot slujitor la Catedrala Episcopală „Sfânta Treime” din Municipiul Baia Mare, începând cu anul 2021.

În anul 2019, cu binecuvântarea și la propunerea Preasfințitului Părinte Iustin, a licențiat Agenția „Pelerinul Creștin”, instituția primind ca și ocrotitoare pe Sfânta Împărăteasă Elena.

Prin sectorul de pelerinaje și Agenția „Pelerinul Creștin” s-au organizat sute de pelerinaje în Israel, Grecia, Cappadocia și Asia Mică, Sfântul Munte Athos, precum și în toate zonele istorice din România: Transilvania, Banat, Oltenia, Muntenia, Dobrogea, Moldova și Bucovina. De asemenea, se organizează pelerinaje personalizate în Maramureș și Satu Mare, se încearcă promovarea, dezvoltarea și dinamizarea turismului religios și de pelerinaj în cuprinsul eparhiei.

În perioada 5-11 februarie 2025, Preasfințitul Părinte Iustin, în fruntea unui grup de monahi, consilieri, protopopi, preoți, preotese și apropiați, au derulat un pelerinaj de suflet în Cappadocia și Asia Mică, coordonat de către părintele Valeriu Mircea Vana, în contextul în care, anul acesta, anul acesta se împlinesc 1700 de ani de la Primul Sinod Ecumenic de la Niceea din anul 325.`}
          </Typography>
          <Box
            sx={{
              width: "100%",
              height: "1px",
              background:
                "linear-gradient(90deg, transparent, #BE9257 50%, transparent)",
              my: 4,
            }}
          />

          <Typography
            variant="body1"
            sx={{
              whiteSpace: "pre-line",
              textAlign: "center",
              lineHeight: 1.7,
              fontFamily: "EB Garamond",
              fontStyle: "italic",
              color: "#800020",
              fontSize: "16px",
              fontWeight: 500,
            }}
          >
            {`Biroul de Presă al Episcopiei Ortodoxe Române a Maramureșului și Sătmarului`}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default PresaSection;
